import { AbstractControl, ValidationErrors } from '@angular/forms';

import XRegExp from 'xregexp';

export const PhoneValidator = (control: AbstractControl): ValidationErrors | null => {
    const value = <string>control.value || '';
    const pattern = '^([+]?)([\\p{N}]{7,20})$';
    if ((value !== '' && value.trim() !== '' && !XRegExp.test(value, XRegExp(pattern))) || (value.trim() === '' && value !== '')) {
        return { invalidCharacters: true };
    }
    return null;
};
